import React from 'react';
export const addFilters = (filters, sortFunction) => ({
  type: 'ADD_FILTERS',
  newFilters: filters,
  sortFunction
});
export const removeFilter = id => ({
  type: 'REMOVE_FILTER',
  id
});
export const replaceAllFilters = newFilters => ({
  type: 'REPLACE_ALL_FILTERS',
  newFilters
});
export const updateFilterState = (filterId, isChecked, isVisible) => ({
  type: 'UPDATE_FILTER_STATE',
  filterId: filterId,
  isChecked,
  isVisible
});
export const replaceAllFiltersAndMaintainChecked = newFilters => ({
  type: 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED',
  newFilters
});
function reducer(state, action) {
  switch (action.type) {
    case 'ADD_FILTERS':
      {
        if (action.newFilters.length === 0) {
          return state;
        }
        let newState = [...state];
        action.newFilters.forEach(f => {
          const index = state.findIndex(filter => filter.id === f.id);
          if (index === -1) {
            newState.push(f);
          } else {
            newState[index] = f;
            return newState;
          }
        });
        action.sortFunction && newState.sort(action.sortFunction);
        return newState;
      }
    case 'UPDATE_FILTER_STATE':
      {
        const index = state.findIndex(filter => filter.id === action.filterId);
        if (index === -1) {
          return state;
        }
        const newState = [...state];
        newState[index] = {
          ...newState[index],
          isChecked: action.isChecked,
          isVisible: action.isVisible === undefined || action.isVisible === null ? newState[index].isVisible : action.isVisible
        };
        return newState;
      }
    case 'REMOVE_FILTER':
      {
        return [...state.filter(filter => filter.id !== action.id)];
      }
    case 'REPLACE_ALL_FILTERS':
      {
        return [...action.newFilters];
      }
    case 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED':
      {
        const newState = action.newFilters.map(newFilter => {
          const existingFilter = state.find(f => f.id === newFilter.id);
          if (existingFilter && newFilter.isVisible) {
            newFilter.isChecked = existingFilter.isChecked;
          }
          return newFilter;
        });
        return newState;
      }
    default:
      // exhaustive check
      const _ = action;
      throw new Error(_);
  }
}
export const useFilter = initialValues => {
  const [state, dispatch] = React.useReducer(reducer, initialValues ? initialValues : []);
  const value = React.useMemo(() => ({
    filters: state,
    dispatch: dispatch
  }), [state, dispatch]);
  return value;
};